import React from 'react'
import styles from './styles.css'
import moment from 'moment'
import VehicleTag from 'App/components/VehicleTag'
import CountryFlag from 'App/components/CountryFlag'

export default function Conversation(props) {
  const {conversation, isSelected} = props
  const {vehicle} = conversation

  if (!vehicle) return null
  return (
    <div className={isSelected ? styles.selected : styles.container} onClick={props.select}>
      <div className={styles.info}>
        {conversation.assignedAdminName ? (
          <div className={styles.assignedAdminName}>{conversation.assignedAdminName}</div>
        ) : (
          <div className={styles.withoutAssignedAdmin}>Sin supervisor</div>
        )}
        <div className={styles.divider} />
        <div className={styles.countryFlag}>
          <CountryFlag code={conversation.countryCode || vehicle.countryCode} />
        </div>
        <div className={styles.zoneName}>{vehicle.zoneName}</div>
        {vehicle.hasActiveOrders ? (
          <div className={styles.hasActiveOrders}>Pedido activo</div>
        ) : null}
      </div>
      <div className={styles.top}>
        <div className={conversation.priority <= 2 ? styles.urgent : styles.priority}>
          P{conversation.priority || 'X'}
        </div>
        <VehicleTag vehicle={vehicle} />
        <div className={styles.date}>{moment(conversation.lastActivityAt).fromNow(true)}</div>
      </div>
      {conversation.isVehicleTyping ? (
        <div className={styles.typing}>Escribiendo...</div>
      ) : conversation.lastMessagePreview ? (
        <div className={conversation.isUnreadByAdmin ? styles.unreadPreview : styles.preview}>
          {conversation.lastMessagePreview}
        </div>
      ) : (
        <div className={styles.noMessages}>Sin mensajes</div>
      )}
    </div>
  )
}
